
/**
 * 사용자 상호작용 정보
 */
export type TrendItemContentTweetsItemUserInteraction = {
  /** 북마크 여부 */
  bookmarked?: boolean;
  /** 좋아요 여부 */
  liked?: boolean;
  /** 재인용 여부 */
  quoted?: boolean;
  /** 신고 여부 */
  reported?: boolean;
  /** 재개시 여부 */
  retweeted?: boolean;
};
